import React from 'react'
import PropTypes from 'prop-types'
import { IntlProvider, addLocaleData } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Route, Switch, withRouter } from 'react-router-dom'

import { fetchAndSwitchLocale } from 'actions/ui'
import { redirectToUser } from 'actions/cellars.js'
import App from 'components/routes/App'

import it from 'react-intl/locale-data/it'
import en from 'react-intl/locale-data/en'
import de from 'react-intl/locale-data/de'
import bg from 'react-intl/locale-data/bg'
// import nl from 'react-intl/locale-data/nl';

addLocaleData(it)
addLocaleData(en)
addLocaleData(de)
addLocaleData(bg)
// addLocaleData(nl);

export class EntryPoint extends React.Component {
  componentDidMount() {
    console.log("entered")
    this.props.fetchLocale(this.props.match.params.lang)
  }

  renderApp() {
    return (
      <IntlProvider
        locale={this.props.locale}
        messages={this.props.messages}
      >
        <Switch>
          <Route
            exact
            path="/:lang/"
            render={({ match }) => {
              let { hostname } = window.location

              hostname = hostname.replace(/(.?)winearound\.com/, '')

              switch (hostname) {
              case '':
                return null
              case 'bookingbutton':
                return null
              default:
                break
              }

              this.props.redirect(hostname, match.params.lang)
              return null
            }}
          />
          <Route
            path="/:lang/:cellarId"
            render={(props) => (
              <App {...this.props} {...props} />
            )}
          />
        </Switch>
      </IntlProvider>
    )
  }

  renderLoading() {
    return (
      <div>
        ...
      </div>
    )
  }

  render() {
    if (!this.props.messages) {
      return this.renderLoading()
    }

    return this.renderApp()
  }
}

EntryPoint.propTypes = {
  locale: PropTypes.string.isRequired,
  match: PropTypes.object.isRequired,
  messages: PropTypes.object,
  fetchLocale: PropTypes.func.isRequired,
  redirect: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => {
  return {
    locale: state.ui.locale,
    messages: state.locales[state.ui.locale],
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchLocale: fetchAndSwitchLocale,
    redirect: redirectToUser,
  }, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EntryPoint))
